import module from 'usuarios/module.js'
import template from './template.html'

export class UsuariosComponent {
  promise = null
  data = []
  dataNatural = []
  dataBusqueda = []
  buscando = false
  completado = false
  contador = 0
  contadorBusqueda = 0
  limite = 50
  q = ''

  constructor (Usuarios) {
    this.usuarios = Usuarios
  }

  $onInit () {
    this.promise = this.usuarios.get(this.contador, this.limite)
      .then(response => (this.data = this.dataNatural = response.data))
      .finally(() => (this.contador = this.contador + this.limite))
  }

  recargar () {
    if (this.buscando) return

    this.buscando = true

    if (!this.q.length) {
      this.usuarios.get(this.contador, this.limite)
        .then(response => {
          this.dataNatural = [...this.dataNatural, ...response.data]
          this.data = this.dataNatural
          this.completado = this.limite > response.data.length
        })
        .finally(() => {
          this.contador = this.contador + this.limite
          this.buscando = false
        })
    } else {
      this.usuarios.get(this.contadorBusqueda, this.limite, this.q)
        .then(response => {
          this.data = this.dataBusqueda = [...this.dataBusqueda, ...response.data]
          this.completado = this.limite > response.data.length
        })
        .finally(() => {
          this.contadorBusqueda = this.contadorBusqueda + this.limite
          this.buscando = false
        })
    }
  }

  regresar (q) {
    if (q.length) {
      this.buscar(q)
    } else {
      this.q = q
      this.recargar()
    }
  }

  buscar (q) {

    if (this.buscando) return

    this.buscando = true

    if (q.length) {

      if (this.q !== q) {
        this.dataBusqueda = []
        this.contadorBusqueda = 0
      }

      this.q = q


      this.usuarios.get(this.contadorBusqueda, this.limite, this.q)
        .then(response => {
          this.data = this.dataBusqueda = [...this.dataBusqueda, ...response.data]
          this.completado = this.limite > response.data.length
        })
        .finally(() => {
          this.contadorBusqueda = this.contadorBusqueda + this.limite
          this.buscando = false
        })
    } else {
      this.dataBusqueda = []
      this.contadorBusqueda = 0
      this.data = this.dataNatural
    }
  }
}

module.component('usuarios', {
  controller: UsuariosComponent,
  template,
})



// WEBPACK FOOTER //
// ./src/usuarios/components/component.js